import { QElement } from "./QElement";
import { QOrphanDraggerPanel } from "./QOrphanDraggerPanel";

export class QParkingElement extends QElement {
  constructor() {
    super();
    this.fDBObj = null;
    this.fParentPanel = null;
  }

  InitParkingElement(theDBObj, parentPanel) {
    this.fDBObj = theDBObj;
    this.fParentPanel = parentPanel;
  }

  GetDataObj() {
    return this.fDBObj;
  }

  //=================================================================================================
  // Drag & Drop
  GetDragPanelClass() {
    return new QOrphanDraggerPanel();
  }

  StartInteractWithElement() {
    var srcPanel = this.fParentPanel;
    var wsMgr = srcPanel.fWSMgr;
    var dstPanel = wsMgr.fCanvasPanel;
    this.SetElementDragInfo(srcPanel, dstPanel);
    return true;
  }
}
